<template lang="pug">
doctype html
div(id="app" :class="{'fix-iphonex-bottom': iphonex,grayscale:grayscale}")
  keep-alive
    router-view(v-if="$route.meta.keepAlive&&isRouterAlive" class="app-view")
  router-view(class="app-view" v-if="!$route.meta.keepAlive&&isRouterAlive")
  .interval(style="width:25px;height:25px;position:fixed;top:0;right:0;z-index:10000" @click="goSettoken")
  //- Vfooter(v-show="hasTabbar&&!isLoading" :currentIndex="currentIndex")
  floatBtn(ref="floatBtn")
  .iphone-footer-bg(:class="{'iphonexshow': iphonex}")
  .loading-fixed(v-show="isLoading")
    img(src="http://img.zx.zoenet.cn/maternalte/icon/loading_logo.gif")
  debugbox(@reload="reload")
</template>

<script>
import Vfooter from './pages/footer/footer'
import floatBtn from './components/float-btn/float-btn.vue'
import debugbox from './pages/common/debugbox.vue';
import {  Dialog } from 'vant'
import {
  mapGetters,
  mapActions
} from 'vuex'
import '@/styles/iconfont/iconfont.js';
export default {
  name: 'app',
  beforeCreate() {},
  provide() {
    return {
      reload: this.reload
    }
  },
  components: {
    Vfooter: Vfooter,debugbox,floatBtn
  },
  data() {
    return {
      path: '',
      title: '智业健康',
      isRouterAlive: true,
      hasTabbar: false,
      currentIndex: 0,
      iphonex: false,
      grayscale: false,
      clickCount:0,
    }
  },
  computed: {
    ...mapGetters(['isLoading'])
  },
  created() {
    this.setWin(window, window['lib'] || (window['lib'] = {}))
    this.routeChange()
    this.setIphonex()
  },
  methods: {
    ...mapActions([
      'showLoading'
    ]),
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      })
    },
    /**
     * 路由切换
     */
    routeChange() {
      var path = this.$route.matched[0] ? this.$route.matched[0].path : '';
      if (path === '/') {
        path = '/maternal/home'
      }
      this.path = path
      // 显示底部
      if ((path === '/maternal/home' || path === '/maternal/mine')&&this.$route.query.footer!=0) {
        this.hasTabbar = true;
      } else {
        this.hasTabbar = false;
      }
      if (path === '/maternal/home') {
        this.currentIndex = 0
      }
      if (path === '/maternal/mine') {
        this.currentIndex = 1
      }
      //获取疫情
      // if (path=='/health/identityChoice') {
      //   this.grayscale = true
      // }
      setTimeout(() => {
        this.title = document.title
      }, 400)
    },
    setToken(res) {
      if (res.token && res.token != '') {
        this.TokenManager.set(res.token);
      }
      this.$router.go(0);
    },
    //跳转settoken
    goSettoken(){
      this.clickCount++
      if(this.clickCount>=3){
        Dialog.confirm({
          title: '温馨提示',
          message: '进入Debug'
        }).then(() => {
          this.$router.push({path:'/common/settoken', query:{returnUrl:location.hash}})
          this.clickCount = 0
        }).catch(() => {
          this.clickCount = 0
        });
      }
    },
    // 判断是否iphonex
    setIphonex(res) {
      let isIphone = /iphone/gi.test(window.navigator.userAgent)
      let windowW = window.screen.width
      let windowH = window.screen.height
      let pixelRatio = parseInt(window.devicePixelRatio)
      let isIPhoneX = isIphone && pixelRatio && pixelRatio === 3 && windowW === 375 && windowH === 812
      let isIPhoneXSMax = isIphone && pixelRatio && pixelRatio === 3 && windowW === 414 && windowH === 896
      let isIPhoneXR = isIphone && pixelRatio && pixelRatio === 2 && windowW === 375 && windowH === 812
      if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
        // 底部增加fix-iphonex-bottm iphone-footer-bg
        this.iphonex = true
      }
    }
  },
  watch: {
    '$route': 'routeChange',
    isLoading(val) {
      if (val) {
        // this.loading.show()
      } else {
        // this.loading.hide()
      }
    },
  },
  mounted() {
    window['appSetToken'] = (res) => {
      this.setToken(res)
    }
  },
  destroyed() {
    // 结束加载
    global.loadingHide();
  }
}
</script>
<style>
@import "~@/styles/base.css";
/* @import "~@/styles/iconfont/iconfont.css"; */
@import '//at.alicdn.com/t/c/font_1080182_2h7q1kr137b.css';
</style>
<style lang="less">
@import "~@/styles/1px.less";
</style>
